import { ELinkRel, EProtocol, ETarget } from './containers/LinkForm/types'

export const AVAILABLE_PROTOCOLS = Object.values(EProtocol)
export const AVAILABLE_RELS = Object.values(ELinkRel)
export const AVAILABLE_TARGETS = Object.values(ETarget)
